<table
  (matSortChange)="onSort($event)"
  [dataSource]="dataSource"
  mat-table
  matSort
  appResizableColumn>
  <ng-container
    *ngFor="let column of tableColumns$ | async"
    matColumnDef="{{ column.name }}">
    <th
      (mousedown)="onColumnResize($event, column.name)"
      *matHeaderCellDef
      mat-sort-header
      mat-header-cell>
      {{ column.text | translate }}
    </th>
    <td *matCellDef="let catalogue" mat-cell>
      {{ catalogue[column.name] }}
    </td>
  </ng-container>

  <tr
    #materialCatalogHeader
    *matHeaderRowDef="displayedColumns; sticky: true"
    class="admia-table-header-row"
    mat-header-row>
  </tr>

  <tr
    #materialCatalogRow
    (click)="onClick(row)"
    (mouseover)="onHover(i)"
    class="admia-table-row"
    *matRowDef="let row; columns: displayedColumns; let i = index"
    [ngClass]="{ selected: i === (selectedIndex$ | async) }"
    mat-row
  ></tr>
</table>
